module.exports = __webpack_public_path__ + "static/media/accountingtabextraimg.4f3f554a.png";